import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Spinner from './Spinner';

const AdminRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);

    // 1. Yükleme Durumu Kontrolü:
    // AuthContext kullanıcı bilgilerini backend'den çekerken beklemesini sağlar.
    // Bu kontrol olmadan, sayfa ilk yüklendiğinde "user" null olacağı için anında anasayfaya atabilir.
    if (loading) {
        return <Spinner />;
    }

    // 2. Yetkilendirme Kontrolü:
    // Yükleme bittikten sonra, kullanıcının var olup olmadığını VE rolünün "admin" olup olmadığını kontrol eder.
    if (!user || user.role !== 'admin') {
        // Eğer kullanıcı giriş yapmamışsa VEYA rolü 'admin' değilse (user veya editor ise),
        // anasayfaya yönlendirilir. Erişim engellenir.
        return <Navigate to="/" />;
    }

    // 3. Yetki Varsa Sayfayı Göster:
    // Eğer yukarıdaki kontrollerin hepsi geçilirse, bu demektir ki kullanıcı giriş yapmış ve rolü 'admin'.
    // Bu durumda, sarmaladığı sayfayı (children) ekranda gösterir.
    return children;
};

export default AdminRoute;